/**
 * Cookieのkey一覧
 */
const CookieKeys = {
  // seqの値
  PLANNING_COM_SEQ: 'seq',
  // ユーザーID
  USER_ID_COOKIE_KEY: 'user_id',
  // ユーザーID
  ID_TOKEN_COOKIE_KEY: 'id_token',
  // SP pkg のスポットブックマーク
  SP_PKG_SPOT_BOOKMARKS: 'pkg_spot_bookmark',
  // SP pkg のログイン情報（会員番号.トークン）
  SP_PKG_LOGIN: 'pkg_login',
  // SP pkg のuuid情報
  SP_PKG_UUID: 'pkg_uuid',
  // cookie使用の許諾情報
  COOKIE_ACCEPT: 'cookie_accept',
};
export { CookieKeys as default };
